export default __webpack_public_path__ + "static/media/W51Living2.db3b3860.jpg";